import React, {FC, useState} from "react";
import isEmpty from "lodash/isEmpty";
import {GridItem} from "@/widget/GridItem/GridItem";
import {useQueryInvoice} from "@/service/invoice.s";
import {ResultWrapper} from "@/widget/ResultWrapper/ResultWrapper";
import Stack from "@mui/material/Stack";
import {Tab, Grid} from "@mui/material";
import {checkQueryKey, formatTime, getRealId, getSellerNames} from "@/helper/method";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import TabContext from "@mui/lab/TabContext";
import {TabPanel} from "@mui/lab";
import {ContractDetail} from "@/widget/CommonDetail/ContractDetail";
import {PaybackTable} from "@/widget/CommonDetail/PaybackTable";
import NoResultsOverlay from "@/widget/NoResultsOverlay/NoResultsOverlay";
import {ModeType, useDialogModal, useDrawerModal} from "@/store/global.c";

export interface ViewInvoiceProps {
    mode: ModeType
}

export const ViewInvoice: FC<ViewInvoiceProps> = ({mode}) => {
    const {id: drawerId} = useDrawerModal()
    const {id: dialogId} = useDialogModal()
    const id: number = getRealId(mode, drawerId, dialogId);
    const {data: invoiceData, isLoading: invoiceLoading} = useQueryInvoice({id}, checkQueryKey(id))
    const invoice = invoiceData?.data
    const [tab, setTab] = useState<number>(1)

    return <> <ResultWrapper isLoading={invoiceLoading} isEmpty={isEmpty(invoice)}>
        <Stack direction={'column'} width={'100%'} gap={2}>
            <Grid
                spacing={3}
                container>
                <GridItem title={'客户名称'} content={invoice?.customerName}/>
                <GridItem title={'服务名称'} content={invoice?.productName}/>
                <GridItem title={'业务人员'} content={getSellerNames(invoice?.creator, invoice?.seller)}/>
                <GridItem title={'开票金额'} content={invoice?.invoiceMoney}/>
                <GridItem title={'开票类型'} content={invoice?.invoiceType}/>
                <GridItem title={'开票公司'} content={invoice?.invoiceCompany}/>
                <GridItem minHeight={'48px'} size={12} title={'备注'} content={invoice?.remark || '-'}/>
                <GridItem title={'更新时间'} content={formatTime('D', invoice?.updatedAt)}/>
                <GridItem title={'创建时间'} content={formatTime('D', invoice?.createdAt)}/>
            </Grid>
            <TabContext value={tab}>
                <Stack direction="column" spacing={2}>
                    <Box sx={{borderBottom: 1, borderTop: 1, pt: 1, borderColor: 'divider'}}>
                        <TabList variant={'fullWidth'} onChange={(event, value) => setTab(value)}>
                            <Tab label="开票" value={1}/>
                            <Tab label="抬头" value={2}/>
                            <Tab label="合同" value={3}/>
                            <Tab label="回款" value={4}/>
                        </TabList>
                    </Box>
                    <TabPanel value={1} sx={{mt: 1, p: 0}}>
                        <Stack gap={2}>
                            <Grid
                                spacing={3}
                                container>
                                <GridItem title={'开票时间'} content={formatTime('D', invoice?.invoiceTime)}/>
                                <GridItem title={'发票号码'} content={invoice?.invoiceNumber}/>
                                <GridItem title={'业务内容'} content={invoice?.invoiceContent}/>
                                <GridItem title={'发票金额'} content={invoice?.invoiceTax}/>
                            </Grid>
                        </Stack>
                    </TabPanel>
                    <TabPanel value={2} sx={{mt: 1, p: 0}}>
                        <Stack gap={2}>
                            <Grid
                                spacing={3}
                                container>
                                <GridItem title={'发票抬头'} content={invoice?.invoiceTitle}/>
                                <GridItem title={'纳税识别号'} content={invoice?.taxNumber}/>
                                <GridItem title={'开户行'} content={invoice?.depositBank}/>
                                <GridItem title={'开户账户'} content={invoice?.depositAccount}/>
                                <GridItem title={'联系电话'} content={invoice?.mobile}/>
                                <GridItem title={'电子邮箱'} content={invoice?.email}/>
                                <GridItem size={12} title={'开票地址'} content={invoice?.depositAddress}/>
                            </Grid>
                        </Stack>
                    </TabPanel>
                    <TabPanel value={3} sx={{mt: 1, p: 0}}>
                        {checkQueryKey(invoice?.contractId) ? <ContractDetail data={invoice?.contract}/>
                            : <Box p={4}><NoResultsOverlay kind={'default'}/></Box>}
                    </TabPanel>
                    <TabPanel value={4} sx={{mt: 1, p: 0}}>
                        <PaybackTable data={invoice?.paybacks}/>
                    </TabPanel>
                </Stack>
            </TabContext>
        </Stack></ResultWrapper>
    </>
}